import { useMemo } from "react";
import { useTranslation } from "react-i18next";

export const projectsPageAddEditProjectDialogK = {
  editProject: "projects_page_add_edit_project_dialog.editProject",
  countryBuildingStandard: "projects_page_add_edit_project_dialog.countryBuildingStandard",
  createProject: "projects_page_add_edit_project_dialog.createProject",
};

export const useProjectsPageAddEditProjectDialogT = () => {
  const { t, i18n } = useTranslation();
  
  return useMemo(
    () => ({
      editProject: t(projectsPageAddEditProjectDialogK.editProject),
      countryBuildingStandard: t(projectsPageAddEditProjectDialogK.countryBuildingStandard),
      createProject: t(projectsPageAddEditProjectDialogK.createProject),
    }),
    [i18n.language]
  );
};